var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.visible, width: "720px", center: "" },
      on: {
        "update:visible": function (val) {
          return _vm.$emit("update:visible", val)
        },
      },
    },
    [
      _c("div", { staticClass: "qrcode-wrapper" }, [
        _vm.title
          ? _c("div", { staticClass: "qrcode-title" }, [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.items && _vm.items.length
          ? _c(
              "div",
              { staticClass: "qrcode-list" },
              _vm._l(_vm.items, function (item) {
                return _c(
                  "div",
                  { key: item.label, staticClass: "qrcode-item" },
                  [
                    _c(
                      "el-image",
                      {
                        staticClass: "qrcode-image",
                        attrs: { src: _vm.toQrImage(item.url), fit: "contain" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "qrcode-error",
                            attrs: { slot: "error" },
                            slot: "error",
                          },
                          [_vm._v("\n            二维码加载失败\n          ")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "qrcode-label" }, [
                      _vm._v(
                        "\n          " + _vm._s(item.label) + "\n        "
                      ),
                    ]),
                  ],
                  1
                )
              }),
              0
            )
          : _c("div", { staticClass: "qrcode-empty" }, [
              _vm._v("\n      暂无二维码图片\n    "),
            ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }